<template>
  <div class="d-flex flex-row justify-content-center align-items-center">
    <div>
      <mdb-btn
        rounded
        size="sm"
        icon="shopping-cart"
        gradient="aqua"
        title="Cart for bulk operations"
        @click="modal = true"
      />
      <span v-if="items.length" class="counter">{{ items.length }}</span>
      <mdb-modal :show="modal" size="fluid" @close="modal = false">
        <mdb-modal-header class="aqua-gradient">
          <mdb-modal-title>Rates Generator</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body style="max-height: none!important">
          <mdb-container class="mw-100 m-0">
            <mdb-row class="w-100 h-100 overflow-hidden m-0">
              <mdb-col col="4" class="border">
                <ul class="list-unstyled">
                  <li
                    v-for="(item, index) in items"
                    :key="`entities-list-item-${index}`"
                  >
                    <admin-tab-cart-item
                      :item="item"
                      :index="index"
                      @remove-item="removeItem($event)"
                    />
                  </li>
                </ul>
              </mdb-col>
              <mdb-col col="8" class="pr-0">
                <admin-client-select
                  class="mt-2"
                  @change="client = $event"
                />
                <mdb-btn
                  size="md"
                  rounded
                  gradient="aqua"
                  @click="selectCombine"
                  class="mb-3"
                >{{ combine ? (combine || '--n/a--') : 'Combine with...' }}</mdb-btn>
                <div v-if="generator.valid">
                  <mdb-card class="border">
                    <mdb-card-header
                      class="cart-card-header"
                      @click.native="expanded.mutations = !expanded.mutations"
                    >
                      Mutations
                      <mdb-icon :icon="expanded.mutations ? 'chevron-up' : 'chevron-down'"/>
                    </mdb-card-header>
                    <mdb-card-body
                      v-show="expanded.mutations"
                      class="animated fadeIn cart-card-body"
                    >
                      <mdb-container>
                        <mdb-row>
                          <mdb-col col="6">
                            <mdb-tbl class="text-xsmall">
                              <mdb-tbl-head>
                                <tr>
                                  <th colspan="3">Extra</th>
                                </tr>
                              </mdb-tbl-head>
                              <mdb-tbl-body>
                                <tr v-for="(ext, i) in extra" :key="`extra-row-${i}`">
                                  <td>{{ ext }}</td>
                                  <td>
                                    <a
                                      @click="extraToInclude(ext)"
                                      title="Move this extra to include"
                                      class="ml-1"
                                    >
                                      <mdb-icon icon="check" color="success"/>
                                    </a>
                                    <a
                                      @click="extraClear(ext)"
                                      title="Clear mutation"
                                      class="mr-1"
                                    >
                                      <mdb-icon icon="times" color="danger"/>
                                    </a>
                                  </td>
                                  <td>
                                    {{ determineExtraMutation(ext) }}
                                  </td>
                                </tr>
                              </mdb-tbl-body>
                            </mdb-tbl>
                          </mdb-col>
                          <mdb-col col="6">
                            <mdb-tbl>
                              <mdb-tbl-head>
                                <tr>
                                  <th colspan="3">Optional</th>
                                </tr>
                              </mdb-tbl-head>
                              <mdb-tbl-body>
                                <tr v-for="(opt, i) in optional" :key="`optional-row-${i}`">
                                  <td>{{ opt }}</td>
                                  <td>
                                    <a
                                      @click="optionalToInclude(opt)"
                                      title="Move this optional to include"
                                      class="ml-1"
                                    >
                                      <mdb-icon icon="check" color="success"/>
                                    </a>
                                    <a
                                      @click="optionalToExtra(opt)"
                                      title="Move this optional to extra"
                                      class="ml-1"
                                    >
                                      <mdb-icon icon="coins" color="warning"/>
                                    </a>
                                    <a
                                      @click="optionalClear(opt)"
                                      title="Clear mutation"
                                      class="mr-1"
                                    >
                                      <mdb-icon icon="times" color="danger"/>
                                    </a>
                                  </td>
                                  <td>
                                    {{ determineOptionalMutation(opt) }}
                                  </td>
                                </tr>
                              </mdb-tbl-body>
                            </mdb-tbl>
                          </mdb-col>
                        </mdb-row>
                      </mdb-container>
                    </mdb-card-body>
                  </mdb-card>
                  <!--<mdb-card class="border mt-3">
                    <mdb-card-header
                      class="cart-card-header"
                      @click.native="expanded.additions = !expanded.additions"
                    >
                      Additions
                      <mdb-icon :icon="expanded.additions ? 'chevron-up' : 'chevron-down'"/>
                    </mdb-card-header>
                    <mdb-card-body
                      v-show="expanded.additions"
                      class="animated fadeIn cart-card-body"
                    >

                    </mdb-card-body>
                  </mdb-card>-->
                  <mdb-card class="border mt-3">
                    <mdb-card-header
                      class="cart-card-header"
                      @click.native="expanded.pricing = !expanded.pricing"
                    >
                      Pricing
                      <mdb-icon :icon="expanded.pricing ? 'chevron-up' : 'chevron-down'"/>
                    </mdb-card-header>
                    <mdb-card-body
                      v-show="expanded.pricing"
                      class="animated fadeIn cart-card-body"
                    >
                      <div class="d-flex flex-row justify-content-around align-items-center">
                        <mdb-switch
                          color="success"
                          off-label="Fixed"
                          on-label="Percent"
                          @getValue="generator.pricing.percent = $event"
                        />
                        <div>
                          <div class="form-group" lang="en-US">
                            <label for="pricing-value">Value</label>
                            <div>
                              <div class="d-inline-block">
                                <input
                                  type="number"
                                  id="pricing-value"
                                  class="form-control d-inline-block"
                                  @change="changePricingValue"
                                >
                              </div>
                              <mdb-icon
                                icon="percent"
                                v-if="generator.pricing.percent"
                              />
                            </div>
                          </div>
<!--                          <mdb-input-->
<!--                            outline-->
<!--                            size="sm"-->
<!--                            label="Value"-->
<!--                            class="d-inline-block"-->
<!--                            :value="generator.pricing.value"-->
<!--                            pattern="[0-9]+([\.][0-9]+)?"-->
<!--                            @change="changePrice($event)"-->
<!--                          />-->

                        </div>
                      </div>
                    </mdb-card-body>
                  </mdb-card>
                </div>
                <p v-else class="text-danger">
                  To generate rates you have to add to cart only root rates
                </p>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn
            :disabled="!generator.valid"
            rounded
            size="sm"
            gradient="aqua"
            @click="generate()"
          >Generate Rates</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
    </div>
  </div>
</template>

<script>
import {
  mdbIcon,
  mdbBtn,
  mdbBtnGroup,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbSwitch,
  mdbInput,
  mdbContainer,
  mdbCard,
  mdbCardHeader,
  mdbCardBody,
  mdbRow,
  mdbCol,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  Bridge8Autocomplete
} from 'mdbvue'
import { EntityTypes } from '../enums'
import AdminTabCartItem from './AdminTabCartItem'
import AdminClientSelect from './AdminClientSelect'
import { mapActions } from 'vuex'
import {errorCatch} from '../utils'
import AdminSelectNodeModal from './AdminSelectNodeModal'

export default {
  name: 'AdminTabCart',
  data () {
    return {
      modal: false,
      expanded: {
        mutations: false,
        additions: false,
        pricing: false
      },
      client: null,
      combine: null,
      items: [],
      include: [],
      extra: [],
      optional: [],
      generator: {
        valid: false,
        pricing: {
          percent: false,
          value: 0
        },
        mutations: {
          extra: {
            include: []
          },
          optional: {
            include: [],
            extra: []
          }
        },
        additions: {
          include: [],
          extra: [],
          optional: []
        }
      }
    }
  },
  computed: {
    uuids: {
      get: function () {
        return this.items.map(item => item.entity.uuid)
      }
    }
  },
  methods: {
    ...mapActions([
      'apiCartValidateRootRates',
      'apiCartGetRatesChildrenTypes',
      'apiGenerateRates'
    ]),
    generate () {
      const data = {
        uuids: this.uuids,
        client: this.client,
        combine: this.combine,
        mutations: this.generator.mutations,
        pricing: this.generator.pricing
      }
      this.apiGenerateRates(data)
        .then(() => {
          this.modal = false
        })
        .catch(errorCatch('Rates Generate Failed', this))
    },
    removeItem (index) {
      this.$delete(this.items, index)
      localStorage.setItem('cart-items', JSON.stringify(this.items))
    },
    refresh () {
      this.apiCartValidateRootRates(this.uuids.concat(this.combine ? [this.combine] : [])).then(valid => {
        this.generator.valid = valid
        this.apiCartGetRatesChildrenTypes(this.uuids).then(data => {
          Object.assign(this, data)
        }).catch(errorCatch('Get Rates Children Types failed', this))
      }).catch(errorCatch('Validation of Root Rates failed with server error', this))
    },
    extraToInclude (ext) {
      this.generator.mutations.extra.include.push(ext)
    },
    extraClear (ext) {
      const index = this.generator.mutations.extra.include.findIndex(x => x === ext)
      if (index > -1) {
        this.$delete(this.generator.mutations.extra.include, index)
      }
    },
    optionalToInclude (opt) {
      this.generator.mutations.optional.include.push(opt)
    },
    optionalToExtra (opt) {
      this.generator.mutations.optional.extra.push(opt)
    },
    optionalClear (opt) {
      let index = this.generator.mutations.optional.include.findIndex(x => x === opt)
      if (index > -1) {
        this.$delete(this.generator.mutations.optional.include, index)
        return
      }
      index = this.generator.mutations.optional.extra.findIndex(x => x === opt)
      if (index > -1) {
        this.$delete(this.generator.mutations.optional.extra, index)
      }
    },
    determineExtraMutation (ext) {
      return this.generator.mutations.extra.include.includes(ext)
        ? 'To Include' : null
    },
    determineOptionalMutation (opt) {
      if (this.generator.mutations.optional.include.includes(opt)) {
        return 'To Include'
      }
      if (this.generator.mutations.optional.extra.includes(opt)) {
        return 'To Extra'
      }
      return null
    },
    changePricingValue (event) {
      const value = event.target.value
      this.generator.pricing.value =
        value !== null ? (parseFloat(value.replace(/,/, '.')) || 0) : 0
    },
    selectCombine () {
      this.$bus.$emit(
        'admin-modal-select-node',
        node => {
          this.combine = node.uuid
          console.log('this.combine:', this.combine)
        }
      )
    }
  },
  mounted () {
    try {
      this.items = JSON.parse(localStorage.getItem('cart-items'))
    } catch (e) {
      this.items = []
    }
    if (!Array.isArray(this.items)) {
      this.items = []
    }
    this.$bus.$on('admin-cart-add-node', node => {
      const entity = {type: EntityTypes.NODE, entity: node}
      if (!this.items.map(item => JSON.stringify(item)).includes(JSON.stringify(entity))) {
        this.items.push(entity)
        localStorage.setItem('cart-items', JSON.stringify(this.items))
      }
    })
  },
  beforeDestroy () {
    this.$bus.$off('admin-cart-add-node')
  },
  watch: {
    combine () {
      if (this.combine !== null) {
        this.refresh()
      }
    },
    items: {
      handler: function () {
        this.refresh()
      },
      deep: true
    }
  },
  components: {
    AdminSelectNodeModal,
    mdbIcon,
    mdbBtn,
    mdbBtnGroup,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalFooter,
    mdbSwitch,
    mdbInput,
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    Bridge8Autocomplete,
    AdminTabCartItem,
    AdminClientSelect
  }
}
</script>

<style lang="sass" scoped>
.cart-card-body
  overflow: auto

.cart-card-header
  cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/AdminTabCart.vue